export enum defaultColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARNING = 'warning',
  DANGER = 'Danger',
  GRAY = 'gray',
  DISABLED = 'disabled'
}
